export default "__VITE_ASSET__Bd3ihnMk__"